export default "__VITE_ASSET__CgeKBQE$__"